import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExAvailabilityDate({
  date,
  expertID,
  setAvailablityDate,
  backupData,
  setBackupData,
}) {
  const [exAvailability, setExAvailability] = useState(null);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [focused, setFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (date) {
      setExAvailability(date);
    }
  }, [date]);

  const handleDateChange = (e) => {
    if (e.target.value === "") {
      return;
    }
    setLoading(true);
    setReturnError(false);
    setExAvailability(new Date(e.target.value));
    setAvailablityDate(new Date(e.target.value));
    const url = `${API_URL}update-available-date`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        expertID: expertID,
        expertAvailability: e.target.value,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expertID) {
                item.expert.Available_from = e.target.value;
              }
              return item;
            })
          );
        } else {
          setExAvailability(date);
          setAvailablityDate(date);
          setReturnError(true);
        }
      })
      .catch((err) => {
        setExAvailability(date);
        setAvailablityDate(date);
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      {exAvailability ? (
        <input
          type="date"
          style={{ height: "23px" }}
          value={new Date(exAvailability).toISOString().slice(0, 10)}
          onBlur={(e) => {
            handleDateChange(e);
            setAvailablityDate(e.target.value);
          }}
          onFocus={() => setFocused(true)}
          onChange={(e) => {
            if (e.target.value === "") return;
            setExAvailability(e.target.value);
          }}
        />
      ) : (
        <input
          type="date"
          style={{ height: "23px" }}
          onBlur={(e) => {
            handleDateChange(e);
            setAvailablityDate(e.target.value);
          }}
          onFocus={() => setFocused(true)}
          onChange={(e) => {
            if (e.target.value === "") return;
            setExAvailability(e.target.value);
          }}
        />
      )}

      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", right: "-14px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", right: "-14px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", right: "-14px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
